import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaiverOsiComponent } from './waiver-osi.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputFieldModule } from '../input-field/input-field.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { OsiComponent } from './osi/osi.component';
import { AlertModule } from '../alert/alert.module';



@NgModule({
  declarations: [WaiverOsiComponent, OsiComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputFieldModule,
    SharedModule,
    AlertModule,
  ],
  exports: [WaiverOsiComponent, OsiComponent]
})
export class WaiverOsiModule { }
